/* */ 
'use strict';
var yaml = require('./lib/js-yaml');
module.exports = yaml;
